import Layout from '@/layout'
export default {
    meta: {
        title: '风险',
        icon: 'b-bx'
    },
    path: "/saferisk",
    component: Layout,
    children: [{
        path: '/saferisk/index',
        name: 'saferiskIndex',
        component: () => import('@/views/saferisk/index'),
        meta: {
            title: '风险管理',
            auth: [],
            img: "azx"
        }
    }, {
        path: '/saferisk/tisindex',
        name: 'saferiskTisindex',
        component: () => import('@/views/saferisk/tisindex'),
        meta: {
            title: '风险管理',
            auth: [],
            img: "azx"
        }
    }, {
        path: '/saferisk/bxindex',
        name: 'saferiskBxindex',
        component: () => import('@/views/saferisk/bxindex'),
        meta: {
            title: '风险管理',
            auth: [],
            img: "azx"
        }
    }, {
        path: '/saferisk/BxService',
        name: 'saferiskBxService',
        component: () => import('@/views/saferisk/BxService'),
        meta: {
            title: '巡查任务',
            auth: [],
            img: "azx"
        }
    }, {
        path: '/saferisk/TisService',
        name: 'saferiskTisService',
        component: () => import('@/views/saferisk/TisService'),
        meta: {
            title: '巡查任务',
            auth: [],
            img: "azx"
        }
    }, {
        path: '/saferisk/detail',
        name: 'saferiskDetail',
        hide: true,
        component: () => import('@/views/saferisk/detail'),
        meta: {
            title: '工程风险管理',
            auth: [],
            img: "idi"
        },
        props: route => {
            return route.query;
        }
    }, {
        path: '/saferisk/detail2',
        name: 'saferiskDetail2',
        hide: true,
        component: () => import('@/views/saferisk/detail2'),
        meta: {
            title: '风险管理详情',
            auth: [],
            img: "idi"
        },
        props: route => {
            return route.query;
        }
    }]
}
